import React from "react";
import classes from "./Main.module.scss";
import {
  MAIN_NO_ASIDE_CLASS_FULL,
  MAIN_HAS_ASIDE_CLASS,
  MAIN_NO_ASIDE_CLASS,
} from "../../../constants/defaults";

const main = ({ hasAside, full, className = "", children, isPaid = true }) => {
  let _queryClasses = hasAside
    ? classes.WithAside + " " + MAIN_HAS_ASIDE_CLASS
    : full
    ? MAIN_NO_ASIDE_CLASS_FULL
    : MAIN_NO_ASIDE_CLASS;

  let _className = className + " " + classes.Main + " " + _queryClasses;

  let content = children;

  

  return (
    <main className={_className}>
      {content}
      {/* {!isPaid && <ModalOnlyPremium />} */}
    </main>
  );
};
export default main;
